// Module
var code = `<template> <div class="page-approval flex-grow-1 column align-items-middle justify-content-center"> <div class="text-container column align-items-middle justify-content-center"> <i class="icon-success material-icons">check_circle</i> <h2 class="registration-text">\${'registration-submitted-text' & t}</h2> </div> </div> </template> `;
// Exports
module.exports = code;